import { useEffect, useRef } from "react";
import { ThreadTurn } from "./Turn";
import type { Turn } from "../useChat";

const OPENERS = [
  "Pet-friendly 2 bedroom in Leslieville under $3,500",
  "Furnished studio with a short lease",
  "Something with a backyard for under $3.5k",
  "Walkable in Roncesvalles with in-unit laundry",
];

export function ChatPage({
  turns,
  busy,
  onSend,
  onOpen,
}: {
  turns: Turn[];
  busy: boolean;
  onSend: (text: string) => void;
  onOpen: (id: string) => void;
}) {
  const scroller = useRef<HTMLElement>(null);

  // Follow the conversation as it grows and as tokens stream in.
  useEffect(() => {
    const node = scroller.current;
    if (node) node.scrollTop = node.scrollHeight;
  }, [turns]);

  return (
    <main className="thread" ref={scroller}>
      <div className="thread-inner">
        {turns.length === 0 ? (
          <section className="hero">
            <h1>Find your next place, by just describing it.</h1>
            <p>
              A thousand rentals across 43 Toronto neighbourhoods. Tell Loop your budget, your area, and whether the
              dog is coming. It will pull the ones that actually fit.
            </p>
            <div className="hero-chips">
              {OPENERS.map((text) => (
                <button className="chip" type="button" key={text} onClick={() => onSend(text)} disabled={busy}>
                  {text}
                </button>
              ))}
            </div>
          </section>
        ) : (
          turns.map((turn) => <ThreadTurn turn={turn} key={turn.key} onOpen={onOpen} />)
        )}
      </div>
    </main>
  );
}
